'use strict';

import React, { Component, Fragment } from 'react';
import $ from 'jquery';
import Form from 'react-jsonschema-form';
import { Button, TableBody, TableRow, TableCell, Box, IconButton } from '@material-ui/core';
import { Group, Close, Create, EditRounded, CloseRounded } from '@material-ui/icons';
import { MiniCard } from '../../../commonModules/layouts/CardPage';
import { TableLayout } from '../Stock/containers/Layout';
import DisplayUserInfo from './DisplayUserInfo';

class ProfileAboutItemPerso extends Component{
    state = {
        error: '',
        styleError: {
            color: 'white'
        },

        info: '',
        values: {},
        form: {
            jsonSchema:{
                properties:{}
            },
            uiSchema:{}
        },
        showUpdateForm:"",
        update:false,
    }

    componentDidMount = () => {
        this.getFamilyInfo()
    }
        
    getFamilyInfo = async () => {
        var methodName = 'Get Family info';
        // var idInfo = this.props.userId;
        // if (idInfo === ''){
        //     idInfo = this.props.boxId;
        // }
        var urlBoxFreeOfAssociation = "/family/info/all?boxAssoId=" + this.props.boxAssoId;

        const response = await fetch(urlBoxFreeOfAssociation,{
            method:'GET',
            headers: { 
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
            },
            credentials: 'same-origin',
        }); 
        const result = await response.json()

            console.log('[INFO], ', methodName);
            console.log(result);
            let info = '';
            try {
                var data = result; //var data = JSON.parse(result);
                info = data.info;
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({
                info: info,
                values:info
            });
      
    }
    componentWillUnmount() {
        try {} catch (e) {
            console.log(e);
        }
    }
    getSchema = async () => {
        console.log('[INFO] get Schema profile user');
            this.setState({
                update:!this.state.update
            })
            // var idInfo = this.props.userId;
            // if (idInfo === ''){
            //     idInfo = this.props.boxId;
            // }
            try {
                if (this.state.update === false) {
                    const infos = await fetch('/schema/getCustomSchema',{
                        method:'POST',
                        headers: { 
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                        },
                        body:JSON.stringify({
                            "idSchema":"family",
                            "boxAssoId": this.props.boxAssoId
                            // "userID": this.props.idInfo
                        }),
                        
                        credentials: 'same-origin',
                    });
                    let body = await infos.json();                

                    this.setState({
                        form:{
                            uiSchema:JSON.parse(body.uiSchema),
                            jsonSchema:JSON.parse(body.jsonSchema),

                        },
                        schemaID:body.schemaID,
                        
                    })
                        
                    console.log("[INFO] get Schema profile user", this.state);  
                }

            } catch (error) {
                console.log("[ERROR] get Schema profile user",error)
                return
            }
    }
    updateInfo = (field) => {
        console.log('[INFO] get forms profile user');
        
        const values = this.state.values;
        const schema = this.state.form.jsonSchema.properties;
        const ui = this.state.form.uiSchema

        if(values){

            let display = values[field];// copy value prevent changing real value
            let specificSchema = {};// will contain current json schema
            let specificUi = {};// will contain current ui schema
            let formDatas = {};// will contain current Db value to prefill the form

            if(Array.isArray(display)){// if value is array, join values
                display = display.join(", ");
            }

            Object.keys(schema).map((schKey, j) => {// get jsonshcema for each field

                if(schKey == field){
                    specificSchema = {
                        "type":"object",
                        "properties":{
                            [schKey]: schema[schKey]
                        }
                    };//..., properties:{Age:{title: "Age", type: "integer", minimum: 16, maximum: 100}}

                    formDatas = {
                        [field]:values[field]
                    };//{"Age":24} = old/DB value
                }
                return;
            });

            Object.keys(ui).map((uiKey) => {//get uishcema for each field
                if(uiKey == field){
                    specificUi = {
                        [uiKey]:ui[uiKey]
                    };
                    //{Age: { ui: widget:"range"}}
                }
                return;
            });

            return[
                specificSchema,
                specificUi,
                formDatas         
            ]

        }
    }
    handleSubmit = async ({formData}) =>{
        //HERE formData is an attribute from the result object of the form
        console.log("[INFO] SUBMIT",formData);
        try {
            // var idInfo = this.props.userId;
            // if (idInfo === ''){
            //     idInfo = this.props.boxId;
            // }

            const infos = await fetch('/schema/updateUser',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    "data":formData,
                    "boxAssoId": this.props.boxAssoId,
                    // "userID": idInfo,
                    "idSchema":"family"
                }),
                
                credentials: 'same-origin',
            });
            let body = await infos.json();                
            console.log("[INFO] submit update profile family", body);  
            if(body.errorCode === 200){
                this.setState({
                    showUpdateForm: ""
                })
                this.getFamilyInfo()
            }

        } catch (error) {
            console.log("[ERROR] submit update profile family",error)
            return
        }
        
    }
    render() {
        const { update, info, showUpdateForm } = this.state;
       
        return (
            info ?
                    <MiniCard 
                        title="Family Info"
                        action={
                            <IconButton onClick={this.getSchema} color="primary" >
                                {this.state.update ? <Close /> : <Create />}
                            </IconButton>
                        }
                        avatar={<Group />}
                    >
                        {/* <Box>
                            <TableLayout>
                                <TableBody>
                                    { this.state.info && infoTmp}
                                </TableBody>
                            </TableLayout>
                        </Box> */}
                        {info &&
                            <DisplayUserInfo
                                {...this.state}
                                updateInfo={this.updateInfo}
                                handleSubmit={this.handleSubmit}
                                updateTarget={(target) => this.setState({
                                    showUpdateForm: target
                                })}

                            />
                        }
                    </MiniCard>
                :
                ""
        )
    }
};

export default ProfileAboutItemPerso
